import styled from "styled-components"
import {
  DefaultTextSize,
  theme,
} from "@aistihealth/web-common/src/util/styles/theme"

export interface ValidationErrorMessageProps {
  size?: DefaultTextSize
}

export const ValidationErrorMessage = styled.label<ValidationErrorMessageProps>`
  ${({ size = "small" }) => theme.textStyle("paragraph", size, "normal")}
  color: ${theme.colors.red};
`
